import { Stack } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { ListLoadingState } from "@src/appV2/redesign/components/ListLoadingState";
import { isEmpty } from "lodash";

import { PageWrapper } from "../../components/PageWrapper";
import { useGetWorkerLicensesAllowedForDocuments } from "../useGetWorkerLicensesAllowedForDocuments";
import { DocumentsPageContent } from "./Content";
import { DocumentsEmptyLicensesPage } from "./EmptyLicensesPage";
import { DocumentsPageHeader } from "./Header/Header";
import { DocumentsNoShiftsPage } from "./NoShiftsPage";
import { DocumentsPageTabNavigation } from "./TabNavigation";
import { useDocumentsPageApiContext } from "./useApiProvider";

export function DocumentsPage() {
  useLogEffect(APP_V2_USER_EVENTS.VIEWED_DOCUMENTS);
  const {
    mandatoryRequirementsQuery: { data: mandatoryRequirements, isSuccess },
  } = useDocumentsPageApiContext();

  const { licenses: availableLicenses, isLoaded: areLicensesLoaded } =
    useGetWorkerLicensesAllowedForDocuments();

  if (!areLicensesLoaded) {
    return <ListLoadingState texts={["Loading documents..."]} />;
  }

  if (isEmpty(availableLicenses)) {
    return <DocumentsEmptyLicensesPage />;
  }

  if (isSuccess && mandatoryRequirements.length === 0) {
    return <DocumentsNoShiftsPage />;
  }

  return (
    <PageWrapper>
      <Stack sx={{ flexGrow: 1, maxHeight: "100%" }}>
        <Stack spacing={7}>
          <DocumentsPageHeader />
          <DocumentsPageTabNavigation />
        </Stack>

        <DocumentsPageContent />
      </Stack>
    </PageWrapper>
  );
}
